import { ClientError } from '@ricoh/ria.client.core/errors';

import type { OverrideConsoleFuncName } from './_logger.type';

import { captureLog, createLogger } from './_api';
import { logLevelText, responseText } from './_styles';

const globalThisCore = globalThis as GlobalThisCore;

const logger = createLogger('logger');

/**
 * Override Console Function.
 *
 * @param {OverrideConsoleFuncName} name Function name.
 */
function overrideConsole(name: OverrideConsoleFuncName) {
  globalThis.console[name] = (
    (originalFunc) =>
    (...args) => {
      try {
        const message = typeof args[0] === 'string' ? args[0] : JSON.stringify(args[0]);
        captureLog(`${logLevelText(name)} ${message}`);
      } catch (exception) {
        const error = ClientError.create({
          module: 'plugin',
          message: 'Cannot capture log',
          cause: exception,
        });

        logger.write('warn', `Cannot capture cause: ${error.message}`);
      } finally {
        originalFunc(...args);
      }
    }
  )(globalThis.console[name]);
}

/** Init logger. */
export function init() {
  globalThisCore.logger = {
    shouldCapture: true,
    logs: [],
  };

  // Handle error event
  globalThis.addEventListener('error', (event) => {
    captureLog(`${event.message}\n${JSON.stringify(event.error)}`);
  });

  // Override console
  overrideConsole('error');
  overrideConsole('warn');
  overrideConsole('info');
  overrideConsole('log');

  logger.write('info', `${responseText('Init')} logger`);
}
